import { ref } from 'vue'

export const waitingEvent = ref(false)
